





















































import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'

@Component()
export default class ChangePasswordDialog extends Vue {

    oldPassword = ''
    newPassword = ''
    newPasswordRepeat = ''

    visible = true
    validating = false
    valid = true
    saving = false

    oldPasswordRules = [
        (v: any) => v !== '' && v !== null ? true : 'This field is required',
    ]

    newPasswordRules = [
        (v: any) => v !== '' && v !== null ? true : 'This field is required',
    ]

    newPasswordRepeatRules = [
        (v: any) => v !== '' && v !== null ? true : 'This field is required',
    ]

    oldPasswordErrors = []
    passwordRepeatErrors = []

    close() {
        this.$router.push({ name: 'home' })
    }

    save() {
        this.validating = true
        if ((this.$refs.form as any).validate() && this.checkPasswordRepeat()) {
            this.changePassword(this.oldPassword, this.newPassword)
        }
    }

    async changePassword(oldPassword, newPassword) {
        try {
            this.saving = true
            const response = await this.$store.dispatch('api/post', {
                path: 'change_password',
                data: { old_password: oldPassword, new_password: newPassword },
            })
            this.close()
        } catch (e) {
            if (e.response.data.old_password) {
                this.oldPasswordErrors = ['Invalid password']
            }
        } finally {
            this.saving = false
        }
    }

    checkPasswordRepeat() {
        if (this.validating && this.newPassword !== this.newPasswordRepeat) {
            this.passwordRepeatErrors = ['Passwords don\'t match']
            return false
        } else {
            this.passwordRepeatErrors = []
            return true
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ChangePasswordDialog.vue